import React from 'react';
import { Save, Plus, Trash2, ArrowUpRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { TabsContent } from '../../components/ui/tabs';
import LandingRoomSection from '../../components/admin/LandingRoomSection';

const LandingPagesContent = ({
  getContent,
  updateField,
  saveContent,
  saveAllForPage,
  openMediaUpload,
  isSaving,
  content,
  ContentSection,
  ImageField,
  allRooms
}) => {
  return (
    <>
      {/* ========================================================================= */}
      {/* 1. LANDING PAGE KHUSUS KELUARGA (/family-hotel-batu)                      */}
      {/* ========================================================================= */}
      <TabsContent value="family_hotel" className="space-y-6">
        <div className="sticky top-0 z-10 bg-emerald-50/95 backdrop-blur-sm py-3 -mt-3 -mx-1 px-1 border-b border-emerald-100 flex justify-between items-center">
          <div>
            <span className="font-semibold text-emerald-950">Landing Page Keluarga</span>
            <span className="text-xs text-gray-500 ml-2">(/family-hotel-batu)</span>
          </div>
          <div className="flex gap-2">
            <a
              href="/family-hotel-batu"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center text-xs text-emerald-700 bg-white border border-emerald-200 px-3 py-1.5 rounded-lg hover:bg-emerald-50"
            >
              Lihat Halaman <ArrowUpRight className="w-3.5 h-3.5 ml-1" />
            </a>
            <Button
              onClick={() => saveAllForPage('family_hotel')}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Semua Konten Keluarga
            </Button>
          </div>
        </div>

        {/* Hero Section */}
        <ContentSection title="Hero Section (Keluarga)">
          <div className="space-y-4">
            <div>
              <Label>Badge / Tag Atas</Label>
              <Input
                value={getContent('family_hotel', 'hero', 'badge', 'Hotel Pilihan Utama Liburan Keluarga di Batu Malang')}
                onChange={(e) => updateField('family_hotel_hero', 'badge', e.target.value)}
                placeholder="Hotel Pilihan Utama Liburan Keluarga..."
              />
            </div>
            <div>
              <Label>Judul Utama (H1)</Label>
              <Input
                value={getContent('family_hotel', 'hero', 'title', 'Liburan Keluarga Nyaman & Tenang di Kota Batu')}
                onChange={(e) => updateField('family_hotel_hero', 'title', e.target.value)}
                placeholder="Liburan Keluarga Nyaman & Tenang di Kota Batu"
              />
            </div>
            <div>
              <Label>Subtitle / Deskripsi Hero</Label>
              <Textarea
                value={getContent('family_hotel', 'hero', 'subtitle', 'Ciptakan momen tak terlupakan bersama buah hati di Spencer Green Hotel Batu. Kamar keluarga luas berpenyejuk alami, kolam renang outdoor segar, sarapan lezat, dan lokasi strategis hanya 5 menit ke Taman Rekreasi Selecta.')}
                onChange={(e) => updateField('family_hotel_hero', 'subtitle', e.target.value)}
                rows={3}
              />
            </div>
            <ImageField
              label="Foto Background Hero"
              value={getContent('family_hotel', 'hero', 'image', 'https://res.cloudinary.com/dgfjos8xa/image/upload/v1767362992/spencer-green-hotel-batu-malang-main-pool-view-building-night_u2ienp.webp')}
              onChange={(e) => updateField('family_hotel_hero', 'image', e.target.value)}
              onUpload={() => openMediaUpload('family_hotel_hero', 'image')}
              altValue={getContent('family_hotel', 'hero', 'imageAlt', 'Family Hotel Batu')}
              onAltChange={(e) => updateField('family_hotel_hero', 'imageAlt', e.target.value)}
            />
            <Button
              onClick={() => saveContent('family_hotel', 'hero', 'hero', content['family_hotel_hero']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Hero
            </Button>
          </div>
        </ContentSection>

        {/* 4 Highlights Bar */}
        <ContentSection title="4 Highlight Utama Keluarga">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { title: 'Kolam Renang Outdoor Ramah Anak', desc: 'Kolam renang luas dengan air jernih dan pemandangan perbukitan hijau. Ada area dangkal yang nyaman untuk anak berenang serta kursi santai untuk orang tua.' },
                { title: 'Sarapan Buffet Nusantara & Kids-Friendly', desc: 'Menu prasmanan lezat di Kenari Restaurant: bubur ayam gurih, pancake/roti bakar, sereal, telur, buah segar, susu, dan jus yang disukai anak-anak.' },
                { title: 'Suasana Asri, Tenang & Aman', desc: 'Halaman hijau terbuka untuk anak berjalan santai di pagi hari dengan udara sejuk bebas polusi khas Punten Bumiaji.' },
                { title: 'Hanya 5 Menit ke Wisata Selecta', desc: 'Lokasi emas di Jl. Raya Punten No. 86. Langsung lurus menuju Taman Rekreasi Selecta tanpa terjebak macet pusat kota Batu.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Highlight #{num}</h4>
                  <div>
                    <Label className="text-xs">Judul Highlight</Label>
                    <Input
                      value={getContent('family_hotel', `highlight_${num}`, 'title', def.title)}
                      onChange={(e) => updateField(`family_hotel_highlight_${num}`, 'title', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('family_hotel', `highlight_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`family_hotel_highlight_${num}`, 'desc', e.target.value)}
                      rows={2}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('family_hotel', `highlight_${num}`, 'section', content[`family_hotel_highlight_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* Kolam Renang, Sarapan & Fasilitas Anak Showcase */}
        <ContentSection title="Showcase: Kolam Renang & Sarapan Anak (Foto & Teks)">
          <div className="space-y-4">
            <div>
              <Label>Judul Bagian</Label>
              <Input
                value={getContent('family_hotel', 'showcase', 'title', 'Kolam Renang Jernih, Sarapan Sedap, & Area Ramah Keluarga')}
                onChange={(e) => updateField('family_hotel_showcase', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Deskripsi Singkat</Label>
              <Textarea
                value={getContent('family_hotel', 'showcase', 'desc', 'Di Spencer Green Hotel Batu, kami mengerti bahwa liburan keluarga yang sukses adalah saat anak-anak bergembira dan orang tua dapat beristirahat dengan damai.')}
                onChange={(e) => updateField('family_hotel_showcase', 'desc', e.target.value)}
                rows={2}
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-2">
              <ImageField
                label="Foto Kolam Renang Anak"
                value={getContent('family_hotel', 'showcase', 'image_pool', 'https://res.cloudinary.com/dgfjos8xa/image/upload/v1767362983/spencer-green-hotel-batu-malang-main-pool_udaykk.jpg')}
                onChange={(e) => updateField('family_hotel_showcase', 'image_pool', e.target.value)}
                onUpload={() => openMediaUpload('family_hotel_showcase', 'image_pool')}
              />
              <ImageField
                label="Foto Sarapan Restoran"
                value={getContent('family_hotel', 'showcase', 'image_breakfast', 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800')}
                onChange={(e) => updateField('family_hotel_showcase', 'image_breakfast', e.target.value)}
                onUpload={() => openMediaUpload('family_hotel_showcase', 'image_breakfast')}
              />
              <ImageField
                label="Foto Fasilitas / Halaman Ramah Anak"
                value={getContent('family_hotel', 'showcase', 'image_playground', 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=800')}
                onChange={(e) => updateField('family_hotel_showcase', 'image_playground', e.target.value)}
                onUpload={() => openMediaUpload('family_hotel_showcase', 'image_playground')}
              />
              <ImageField
                label="Foto Pool Cafe & Santai"
                value={getContent('family_hotel', 'showcase', 'image_cafe', 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800')}
                onChange={(e) => updateField('family_hotel_showcase', 'image_cafe', e.target.value)}
                onUpload={() => openMediaUpload('family_hotel_showcase', 'image_cafe')}
              />
            </div>
            <Button
              onClick={() => saveContent('family_hotel', 'showcase', 'section', content['family_hotel_showcase']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Showcase
            </Button>
          </div>
        </ContentSection>

        {/* Wisata Keluarga Dekat Hotel (Selecta dkk) */}
        <ContentSection title="Destinasi Wisata Sekitar Hotel">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { name: 'Taman Rekreasi Selecta', distance: '2.8 km', time: '± 5 Menit', image: 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=600', desc: 'Taman bunga legendaris dengan waterpark anak, perahu ayun, sky bike, dan udara sejuk pegunungan.' },
                { name: 'Wisata Petik Apel Punten', distance: '1.2 km', time: '± 3 Menit', image: 'https://images.unsplash.com/photo-1560806887-1e4cd0b6cbd6?w=600', desc: 'Edukasi seru memetik apel Batu langsung dari kebun bersama anak dan keluarga.' },
                { name: 'Coban Talun & Oyot', distance: '4.5 km', time: '± 8 Menit', image: 'https://images.unsplash.com/photo-1511497584788-87676104235f?w=600', desc: 'Keindahan air terjun alami dengan spot foto menarik, taman bunga, dan wahana outdoor ramah keluarga.' },
                { name: 'Batu Secret Zoo & Jatim Park 2', distance: '7.5 km', time: '± 18 Menit', image: 'https://images.unsplash.com/photo-1534567153574-2b12153a87f0?w=600', desc: 'Kebun binatang modern bertaraf internasional dan Museum Satwa terlengkap di Indonesia.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Destinasi #{num}</h4>
                  <div>
                    <Label className="text-xs">Nama Wisata</Label>
                    <Input
                      value={getContent('family_hotel', `dest_${num}`, 'name', def.name)}
                      onChange={(e) => updateField(`family_hotel_dest_${num}`, 'name', e.target.value)}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <Label className="text-xs">Jarak</Label>
                      <Input
                        value={getContent('family_hotel', `dest_${num}`, 'distance', def.distance)}
                        onChange={(e) => updateField(`family_hotel_dest_${num}`, 'distance', e.target.value)}
                      />
                    </div>
                    <div>
                      <Label className="text-xs">Waktu Tempuh</Label>
                      <Input
                        value={getContent('family_hotel', `dest_${num}`, 'time', def.time)}
                        onChange={(e) => updateField(`family_hotel_dest_${num}`, 'time', e.target.value)}
                      />
                    </div>
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('family_hotel', `dest_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`family_hotel_dest_${num}`, 'desc', e.target.value)}
                      rows={2}
                    />
                  </div>
                  <ImageField
                    label="Foto Wisata"
                    value={getContent('family_hotel', `dest_${num}`, 'image', def.image)}
                    onChange={(e) => updateField(`family_hotel_dest_${num}`, 'image', e.target.value)}
                    onUpload={() => openMediaUpload(`family_hotel_dest_${num}`, 'image')}
                  />
                  <Button
                    size="sm"
                    onClick={() => saveContent('family_hotel', `dest_${num}`, 'destination', content[`family_hotel_dest_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Destinasi #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* CTA Bawah */}
        <ContentSection title="CTA Banner (Bawah)">
          <div className="space-y-4">
            <div>
              <Label>Judul CTA</Label>
              <Input
                value={getContent('family_hotel', 'cta', 'title', 'Jadikan Liburan Keluarga di Batu Lebih Berkesan')}
                onChange={(e) => updateField('family_hotel_cta', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Subtitle CTA</Label>
              <Textarea
                value={getContent('family_hotel', 'cta', 'subtitle', 'Dapatkan harga kamar terbaik langsung di website resmi Spencer Green Hotel Batu tanpa biaya tersembunyi.')}
                onChange={(e) => updateField('family_hotel_cta', 'subtitle', e.target.value)}
                rows={2}
              />
            </div>
            <Button
              onClick={() => saveContent('family_hotel', 'cta', 'cta', content['family_hotel_cta']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan CTA
            </Button>
          </div>
        </ContentSection>

        <LandingRoomSection
          page="family_hotel"
          defaultTitle="Pilihan Kamar Keluarga"
          defaultSubtitle="Foto & Tipe Kamar Liburan Keluarga"
          rooms={allRooms}
          content={content}
          saveContent={saveContent}
          openMediaUpload={openMediaUpload}
          isSaving={isSaving}
        />
      </TabsContent>

      {/* ========================================================================= */}
      {/* 2. LANDING PAGE KHUSUS SELECTA (/hotel-dekat-selecta)                     */}
      {/* ========================================================================= */}
      <TabsContent value="selecta" className="space-y-6">
        <div className="sticky top-0 z-10 bg-emerald-50/95 backdrop-blur-sm py-3 -mt-3 -mx-1 px-1 border-b border-emerald-100 flex justify-between items-center">
          <div>
            <span className="font-semibold text-emerald-950">Landing Page Dekat Selecta</span>
            <span className="text-xs text-gray-500 ml-2">(/hotel-dekat-selecta)</span>
          </div>
          <div className="flex gap-2">
            <a
              href="/hotel-dekat-selecta"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center text-xs text-emerald-700 bg-white border border-emerald-200 px-3 py-1.5 rounded-lg hover:bg-emerald-50"
            >
              Lihat Halaman <ArrowUpRight className="w-3.5 h-3.5 ml-1" />
            </a>
            <Button
              onClick={() => saveAllForPage('selecta')}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Semua Konten Selecta
            </Button>
          </div>
        </div>

        {/* Hero Section */}
        <ContentSection title="Hero Section (Selecta)">
          <div className="space-y-4">
            <div>
              <Label>Badge Atas</Label>
              <Input
                value={getContent('selecta', 'hero', 'badge', 'Lokasi Terbaik Wisatawan Selecta Kota Batu')}
                onChange={(e) => updateField('selecta_hero', 'badge', e.target.value)}
              />
            </div>
            <div>
              <Label>Judul Utama (H1)</Label>
              <Input
                value={getContent('selecta', 'hero', 'title', 'Hotel Paling Dekat ke Selecta Batu – Hanya 5 Menit')}
                onChange={(e) => updateField('selecta_hero', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Deskripsi / Subtitle</Label>
              <Textarea
                value={getContent('selecta', 'hero', 'subtitle', 'Tinggal selangkah dari pesona bunga abadi dan wahana rekreasi legendaris Selecta. Berlokasi prima di Jl. Raya Punten No. 86, bebas macet pusat kota, lengkap dengan kolam renang outdoor dan pemandangan pegunungan segar.')}
                onChange={(e) => updateField('selecta_hero', 'subtitle', e.target.value)}
                rows={3}
              />
            </div>
            <ImageField
              label="Foto Background Hero"
              value={getContent('selecta', 'hero', 'image', 'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=1600')}
              onChange={(e) => updateField('selecta_hero', 'image', e.target.value)}
              onUpload={() => openMediaUpload('selecta_hero', 'image')}
            />
            <Button
              onClick={() => saveContent('selecta', 'hero', 'hero', content['selecta_hero']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Hero
            </Button>
          </div>
        </ContentSection>

        {/* Quick Metrics */}
        <ContentSection title="Data Cepat / Metrik Selecta">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div>
              <Label className="text-xs">Jarak Tempuh</Label>
              <Input
                value={getContent('selecta', 'metrics', 'distance', '2.8 km')}
                onChange={(e) => updateField('selecta_metrics', 'distance', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-xs">Waktu Tempuh</Label>
              <Input
                value={getContent('selecta', 'metrics', 'duration', '± 5 Menit')}
                onChange={(e) => updateField('selecta_metrics', 'duration', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-xs">Jam Buka Selecta</Label>
              <Input
                value={getContent('selecta', 'metrics', 'hours', '06.00 - 17.00 WIB')}
                onChange={(e) => updateField('selecta_metrics', 'hours', e.target.value)}
              />
            </div>
            <div>
              <Label className="text-xs">Akses Kendaraan</Label>
              <Input
                value={getContent('selecta', 'metrics', 'access', 'Mobil, Elf, & Bus Besar')}
                onChange={(e) => updateField('selecta_metrics', 'access', e.target.value)}
              />
            </div>
          </div>
          <div className="pt-3">
            <Button
              onClick={() => saveContent('selecta', 'metrics', 'metrics', content['selecta_metrics']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Metrik
            </Button>
          </div>
        </ContentSection>

        {/* 4 Keunggulan Menginap */}
        <ContentSection title="4 Keunggulan Menginap Dekat Selecta">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { title: 'Hanya 5 Menit (2.8 KM) ke Gerbang Selecta', desc: 'Spencer Green Hotel terletak di Jl. Raya Punten No. 86. Satu garis lurus ke gerbang Selecta tanpa rute memutar atau jalan sempit.' },
                { title: 'Bebas Macet Jalur Pusat Kota Batu', desc: 'Hindari macet panjang 45–60 menit dari pusat kota Batu. Anda bisa berangkat pagi santai dan tiba pertama saat Selecta baru buka.' },
                { title: 'Mandi Air Panas Hangat Pasca Berenang', desc: 'Air di Selecta terkenal sangat dingin. Pulang ke hotel hanya 5 menit, Anda dan anak-anak bisa langsung mandi air hangat melimpah 24 jam.' },
                { title: 'Restoran & Cafe Siap Menyambut', desc: 'Setelah lelah berkeliling taman bunga Selecta, nikmati makan siang nikmat di Kenari Restaurant atau santai ngopi di Rintik Rindu Rooftop.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Keunggulan #{num}</h4>
                  <div>
                    <Label className="text-xs">Judul</Label>
                    <Input
                      value={getContent('selecta', `advantage_${num}`, 'title', def.title)}
                      onChange={(e) => updateField(`selecta_advantage_${num}`, 'title', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('selecta', `advantage_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`selecta_advantage_${num}`, 'desc', e.target.value)}
                      rows={2}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('selecta', `advantage_${num}`, 'section', content[`selecta_advantage_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Keunggulan #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* Itinerary Guide / Tips */}
        <ContentSection title="Itinerary / Tips Berkunjung ke Selecta">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { time: '06.30 - 07.30 WIB', title: 'Sarapan Pagi di Kenari Restaurant', desc: 'Isi energi keluarga dengan sarapan prasmanan nusantara bergizi di hotel sebelum berangkat.' },
                { time: '07.45 WIB', title: 'Berangkat 5 Menit ke Selecta', desc: 'Perjalanan super singkat 2.8 km dari Spencer Green Hotel. Jalan mulus dan bebas antrean macet.' },
                { time: '08.00 - 11.30 WIB', title: 'Waktu Foto Bunga & Wahana Terbaik', desc: 'Pagi hari adalah waktu emas: udara sejuk berembun, bunga bermekaran cerah, dan wahana belum padat antrean.' },
                { time: '12.00 WIB', title: 'Kembali Cepat ke Hotel untuk Relaksasi', desc: 'Kembali ke hotel dalam hitungan menit untuk istirahat, bilas air hangat, dan makan siang santai.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <div className="flex justify-between items-center">
                    <h4 className="font-semibold text-gray-900 text-sm">Jadwal #{num}</h4>
                  </div>
                  <div>
                    <Label className="text-xs">Waktu / Jam</Label>
                    <Input
                      value={getContent('selecta', `tip_${num}`, 'time', def.time)}
                      onChange={(e) => updateField(`selecta_tip_${num}`, 'time', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Judul Aktivitas</Label>
                    <Input
                      value={getContent('selecta', `tip_${num}`, 'title', def.title)}
                      onChange={(e) => updateField(`selecta_tip_${num}`, 'title', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('selecta', `tip_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`selecta_tip_${num}`, 'desc', e.target.value)}
                      rows={2}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('selecta', `tip_${num}`, 'section', content[`selecta_tip_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Tips #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* CTA Bawah */}
        <ContentSection title="CTA Banner (Bawah)">
          <div className="space-y-4">
            <div>
              <Label>Judul CTA</Label>
              <Input
                value={getContent('selecta', 'cta', 'title', 'Siap Liburan Tanpa Macet ke Selecta Batu?')}
                onChange={(e) => updateField('selecta_cta', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Subtitle CTA</Label>
              <Textarea
                value={getContent('selecta', 'cta', 'subtitle', 'Pesan kamar Anda sekarang untuk mendapatkan harga terbaik dan konfirmasi ketersediaan instan.')}
                onChange={(e) => updateField('selecta_cta', 'subtitle', e.target.value)}
                rows={2}
              />
            </div>
            <Button
              onClick={() => saveContent('selecta', 'cta', 'cta', content['selecta_cta']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan CTA
            </Button>
          </div>
        </ContentSection>

        <LandingRoomSection
          page="selecta"
          defaultTitle="Pilihan Kamar"
          defaultSubtitle="Menginap Nyaman Dekat Selecta"
          rooms={allRooms}
          content={content}
          saveContent={saveContent}
          openMediaUpload={openMediaUpload}
          isSaving={isSaving}
        />
      </TabsContent>

      {/* ========================================================================= */}
      {/* 3. LANDING PAGE MOUNTAIN VIEW (/mountain-view-hotel-batu)                 */}
      {/* ========================================================================= */}
      <TabsContent value="mountain_view" className="space-y-6">
        <div className="sticky top-0 z-10 bg-emerald-50/95 backdrop-blur-sm py-3 -mt-3 -mx-1 px-1 border-b border-emerald-100 flex justify-between items-center">
          <div>
            <span className="font-semibold text-emerald-950">Landing Page Mountain View</span>
            <span className="text-xs text-gray-500 ml-2">(/mountain-view-hotel-batu)</span>
          </div>
          <div className="flex gap-2">
            <a
              href="/mountain-view-hotel-batu"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center text-xs text-emerald-700 bg-white border border-emerald-200 px-3 py-1.5 rounded-lg hover:bg-emerald-50"
            >
              Lihat Halaman <ArrowUpRight className="w-3.5 h-3.5 ml-1" />
            </a>
            <Button
              onClick={() => saveAllForPage('mountain_view')}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Semua Konten Mountain View
            </Button>
          </div>
        </div>

        {/* Hero Section */}
        <ContentSection title="Hero Section (Mountain View)">
          <div className="space-y-4">
            <div>
              <Label>Badge Atas</Label>
              <Input
                value={getContent('mountain_view', 'hero', 'badge', 'Hotel View Pegunungan Terbaik di Kota Batu Malang')}
                onChange={(e) => updateField('mountain_view_hero', 'badge', e.target.value)}
              />
            </div>
            <div>
              <Label>Judul Utama (H1)</Label>
              <Input
                value={getContent('mountain_view', 'hero', 'title', 'Bangun Pagi Berteman Pesona Megah Pegunungan Batu')}
                onChange={(e) => updateField('mountain_view_hero', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Deskripsi / Subtitle</Label>
              <Textarea
                value={getContent('mountain_view', 'hero', 'subtitle', 'Rasakan magisnya panorama Gunung Panderman dan lereng perbukitan hijau Punten langsung dari balkon kamar Anda. Berhawa sejuk alami 18°C, bebas polusi, dan menenangkan jiwa.')}
                onChange={(e) => updateField('mountain_view_hero', 'subtitle', e.target.value)}
                rows={3}
              />
            </div>
            <ImageField
              label="Foto Background Hero"
              value={getContent('mountain_view', 'hero', 'image', 'https://res.cloudinary.com/dgfjos8xa/image/upload/v1767362992/spencer-green-hotel-batu-malang-main-pool-view-building-night_u2ienp.webp')}
              onChange={(e) => updateField('mountain_view_hero', 'image', e.target.value)}
              onUpload={() => openMediaUpload('mountain_view_hero', 'image')}
            />
            <Button
              onClick={() => saveContent('mountain_view', 'hero', 'hero', content['mountain_view_hero']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Hero
            </Button>
          </div>
        </ContentSection>

        {/* 4 Keistimewaan Mountain View */}
        <ContentSection title="4 Keistimewaan Panorama Dataran Tinggi">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { title: 'Panorama Gunung Panderman & Lereng Arjuno', desc: 'Nikmati kemegahan siluet Gunung Panderman dan bukit hijau Punten Bumiaji tanpa terhalang gedung-gedung bertingkat.' },
                { title: 'Balkon Privat Menghadap Bukit', desc: 'Setiap kamar tipe Deluxe & Executive dilengkapi balkon pribadi untuk menikmati kopi pagi berteman sejuknya kabut pegunungan.' },
                { title: 'Hawa Dingin Alami 18°C – 22°C', desc: 'Berada di dataran tinggi Punten, rasakan kesejukan murni yang menyegarkan tubuh dan pikiran, bebas polusi udara perkotaan.' },
                { title: 'Rooftop Cafe & Kolam Renang Berlatar Alam', desc: 'Rintik Rindu Pool Cafe di rooftop menawarkan pemandangan sunset memukau di kala senja dan gemerlap city light di malam hari.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Keistimewaan #{num}</h4>
                  <div>
                    <Label className="text-xs">Judul</Label>
                    <Input
                      value={getContent('mountain_view', `feature_${num}`, 'title', def.title)}
                      onChange={(e) => updateField(`mountain_view_feature_${num}`, 'title', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('mountain_view', `feature_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`mountain_view_feature_${num}`, 'desc', e.target.value)}
                      rows={2}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('mountain_view', `feature_${num}`, 'section', content[`mountain_view_feature_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* 4 Waktu Siklus 24 Jam */}
        <ContentSection title="Siklus 24 Jam Pemandangan Alam">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { tag: '05.30 - 08.00 WIB', title: 'Pagi Hari: Lautan Kabut & Sunrise Emas', desc: 'Bangun tidur dengan embun segar di kaca jendela dan semburat cahaya fajar keemasan yang menyinari puncak perbukitan.' },
                { tag: '10.00 - 15.00 WIB', title: 'Siang Hari: Kontur Bukit Hijau Mempesona', desc: 'Langit biru bersih berpadu dengan hijaunya kebun apel dan pepohonan pinus perbukitan Punten Bumiaji.' },
                { tag: '16.30 - 18.00 WIB', title: 'Senja Hari: Sunset Magis di Balik Gunung', desc: 'Saksikan langit jingga keunguan dari balkon kamar atau area kolam renang outdoor saat matahari perlahan tenggelam.' },
                { tag: '18.30 - 22.00 WIB', title: 'Malam Hari: Kerlap-Kerlip Lampu Kota (City Light)', desc: 'Udara dingin malam yang syahdu ditemani teh hangat sambil memandang ribuan lampu Kota Batu dari ketinggian.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Waktu #{num}</h4>
                  <div>
                    <Label className="text-xs">Jam / Rentang Waktu</Label>
                    <Input
                      value={getContent('mountain_view', `time_${num}`, 'tag', def.tag)}
                      onChange={(e) => updateField(`mountain_view_time_${num}`, 'tag', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Judul Suasana</Label>
                    <Input
                      value={getContent('mountain_view', `time_${num}`, 'title', def.title)}
                      onChange={(e) => updateField(`mountain_view_time_${num}`, 'title', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('mountain_view', `time_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`mountain_view_time_${num}`, 'desc', e.target.value)}
                      rows={2}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('mountain_view', `time_${num}`, 'section', content[`mountain_view_time_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Waktu #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* 6 Foto Galeri Visual */}
        <ContentSection title="6 Foto Galeri Visual Mountain View">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((num) => {
              const defaults = [
                { url: 'https://res.cloudinary.com/dgfjos8xa/image/upload/v1767362992/spencer-green-hotel-batu-malang-main-pool-view-building-night_u2ienp.webp', caption: 'Pemandangan Kolam Renang & Gedung Hotel di Ketinggian' },
                { url: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800', caption: 'Kamar Deluxe dengan Jendela Panorama Pegunungan' },
                { url: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800', caption: 'Executive Suite Balkon View Bukit Hijau' },
                { url: 'https://res.cloudinary.com/dgfjos8xa/image/upload/v1767362983/spencer-green-hotel-batu-malang-main-pool_udaykk.jpg', caption: 'Berenang di Kolam Outdoor Berlatar Bukit Asri' },
                { url: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800', caption: 'Makan Malam & Ngopi Santai di Kenari Restaurant' },
                { url: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800', caption: 'Suasana Restoran dengan Pemandangan Alam' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Foto Galeri #{num}</h4>
                  <ImageField
                    label="Pilih / Upload Foto"
                    value={getContent('mountain_view', `gallery_${num}`, 'image', def.url)}
                    onChange={(e) => updateField(`mountain_view_gallery_${num}`, 'image', e.target.value)}
                    onUpload={() => openMediaUpload(`mountain_view_gallery_${num}`, 'image')}
                  />
                  <div>
                    <Label className="text-xs">Caption Foto</Label>
                    <Input
                      value={getContent('mountain_view', `gallery_${num}`, 'caption', def.caption)}
                      onChange={(e) => updateField(`mountain_view_gallery_${num}`, 'caption', e.target.value)}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('mountain_view', `gallery_${num}`, 'image', content[`mountain_view_gallery_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Foto #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* CTA Bawah */}
        <ContentSection title="CTA Banner (Bawah)">
          <div className="space-y-4">
            <div>
              <Label>Judul CTA</Label>
              <Input
                value={getContent('mountain_view', 'cta', 'title', 'Siap Menikmati Sejuknya Pagi dengan View Gunung di Batu?')}
                onChange={(e) => updateField('mountain_view_cta', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Subtitle CTA</Label>
              <Textarea
                value={getContent('mountain_view', 'cta', 'subtitle', 'Dapatkan kamar favorit lantai atas sebelum kehabisan. Reservasi online langsung dengan konfirmasi cepat.')}
                onChange={(e) => updateField('mountain_view_cta', 'subtitle', e.target.value)}
                rows={2}
              />
            </div>
            <Button
              onClick={() => saveContent('mountain_view', 'cta', 'cta', content['mountain_view_cta']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan CTA
            </Button>
          </div>
        </ContentSection>

        <LandingRoomSection
          page="mountain_view"
          defaultTitle="Pilihan Kamar"
          defaultSubtitle="Kamar dengan Panorama Pegunungan"
          rooms={allRooms}
          content={content}
          saveContent={saveContent}
          openMediaUpload={openMediaUpload}
          isSaving={isSaving}
        />
      </TabsContent>

      {/* ========================================================================= */}
      {/* 4. LANDING PAGE CORPORATE & GROUP (/corporate-gathering-batu)             */}
      {/* ========================================================================= */}
      <TabsContent value="corporate_group" className="space-y-6">
        <div className="sticky top-0 z-10 bg-emerald-50/95 backdrop-blur-sm py-3 -mt-3 -mx-1 px-1 border-b border-emerald-100 flex justify-between items-center">
          <div>
            <span className="font-semibold text-emerald-950">Landing Page Corporate & Group</span>
            <span className="text-xs text-gray-500 ml-2">(/corporate-gathering-batu)</span>
          </div>
          <div className="flex gap-2">
            <a
              href="/corporate-gathering-batu"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center text-xs text-emerald-700 bg-white border border-emerald-200 px-3 py-1.5 rounded-lg hover:bg-emerald-50"
            >
              Lihat Halaman <ArrowUpRight className="w-3.5 h-3.5 ml-1" />
            </a>
            <Button
              onClick={() => saveAllForPage('corporate_group')}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Semua Konten Corporate
            </Button>
          </div>
        </div>

        {/* Hero Section */}
        <ContentSection title="Hero Section (Corporate & Group)">
          <div className="space-y-4">
            <div>
              <Label>Badge Atas</Label>
              <Input
                value={getContent('corporate_group', 'hero', 'badge', 'Solusi Lengkap Corporate Event & Rombongan di Batu Malang')}
                onChange={(e) => updateField('corporate_group_hero', 'badge', e.target.value)}
              />
            </div>
            <div>
              <Label>Judul Utama (H1)</Label>
              <Input
                value={getContent('corporate_group', 'hero', 'title', 'Venue Terbaik Gathering Perusahaan, Instansi & Rombongan')}
                onChange={(e) => updateField('corporate_group_hero', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Deskripsi / Subtitle</Label>
              <Textarea
                value={getContent('corporate_group', 'hero', 'subtitle', 'Ciptakan acara yang sukses dan berkesan di Spencer Green Hotel Batu. Fasilitas ruang pertemuan & ballroom modern, area outbound hijau, prasmanan lezat Kenari Restaurant, kamar luas, serta parkir bus pariwisata yang luas.')}
                onChange={(e) => updateField('corporate_group_hero', 'subtitle', e.target.value)}
                rows={3}
              />
            </div>
            <ImageField
              label="Foto Background Hero Ballroom / Event"
              value={getContent('corporate_group', 'hero', 'image', 'https://res.cloudinary.com/dgfjos8xa/image/upload/v1767363047/event-meeting-hall-ballroom-spencer-green-hotel-batu-malang-main_vi4ivf.avif')}
              onChange={(e) => updateField('corporate_group_hero', 'image', e.target.value)}
              onUpload={() => openMediaUpload('corporate_group_hero', 'image')}
            />
            <Button
              onClick={() => saveContent('corporate_group', 'hero', 'hero', content['corporate_group_hero']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Hero
            </Button>
          </div>
        </ContentSection>

        {/* 5 Segmen Target Rombongan */}
        <ContentSection title="5 Segmen Target Rombongan (Instansi, Perusahaan, Sekolah, Tour, Komunitas)">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5].map((num) => {
              const defaults = [
                { title: 'Instansi Pemerintah & BUMN', tag: 'Raker, Bimtek & Konsinyering', desc: 'Didukung fasilitas meeting berstandar kedinasan, kelengkapan administrasi SPJ & invoice resmi, ruang sidang representatif, dan paket fullboard meeting fleksibel.' },
                { title: 'Gathering Perusahaan & Outing', tag: 'Employee Gathering & Outbound', desc: 'Perkuat soliditas tim di udara sejuk Kota Batu. Tersedia halaman outdoor hijau untuk ice breaking / outbound, panggung musik, gala dinner prasmanan, dan doorprize venue.' },
                { title: 'Sekolah & Universitas', tag: 'Study Tour, LDKS & Perpisahan', desc: 'Akomodasi aman dan terpercaya untuk rombongan pelajar & mahasiswa. Lokasi strategis hanya 5 menit ke Selecta, menu prasmanan higienis, dan kapasitas kamar fleksibel.' },
                { title: 'Rombongan Wisata (Tour & Travel)', tag: 'Family Tour & Biro Perjalanan', desc: 'Parkir bus pariwisata yang luas di dalam hotel, proses check-in rombongan cepat dan terkoordinasi, serta transit makan prasmanan yang higienis dan lezat.' },
                { title: 'Komunitas & Organisasi', tag: 'Kopdar, Klub Motor/Mobil & Reuni', desc: 'Tempat berkumpul yang asyik dan prestisius. Bersantai di rooftop cafe Rintik Rindu, berfoto dengan latar pegunungan megah, dan fasilitas barbecue santai.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Segmen #{num}</h4>
                  <div>
                    <Label className="text-xs">Nama Segmen</Label>
                    <Input
                      value={getContent('corporate_group', `segment_${num}`, 'title', def.title)}
                      onChange={(e) => updateField(`corporate_group_segment_${num}`, 'title', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Tag / Jenis Acara</Label>
                    <Input
                      value={getContent('corporate_group', `segment_${num}`, 'tag', def.tag)}
                      onChange={(e) => updateField(`corporate_group_segment_${num}`, 'tag', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('corporate_group', `segment_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`corporate_group_segment_${num}`, 'desc', e.target.value)}
                      rows={3}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('corporate_group', `segment_${num}`, 'section', content[`corporate_group_segment_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Segmen #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* 4 Fasilitas Khusus Acara */}
        <ContentSection title="4 Fasilitas Pendukung Acara Skala Besar">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { title: 'Meeting Rooms & Ballroom', desc: 'Pilihan ruang fleksibel: Boardroom, Class Room, hingga Conference Hall berkapasitas hingga 200 peserta lengkap dengan AC dan pencahayaan optimal.' },
                { title: 'Audio Visual & Sound System', desc: 'Screen projector HD, wireless microphones, sound system panggung berkualitas, podium pembicara, flipchart, dan sambungan internet berkecepatan tinggi.' },
                { title: 'Parkir Bus Pariwisata', desc: 'Area parkir luas di dalam kompleks hotel untuk mobil pribadi, minibus Elf, hingga bus besar pariwisata dengan penjagaan keamanan 24 jam.' },
                { title: 'Catering Prasmanan Berskala Besar', desc: 'Kenari Restaurant siap menyajikan sarapan, makan siang, gala dinner, dan coffee break tepat waktu dengan standar higienis dan rasa masakan yang lezat.' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Fasilitas #{num}</h4>
                  <div>
                    <Label className="text-xs">Nama Fasilitas</Label>
                    <Input
                      value={getContent('corporate_group', `facility_${num}`, 'title', def.title)}
                      onChange={(e) => updateField(`corporate_group_facility_${num}`, 'title', e.target.value)}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Deskripsi</Label>
                    <Textarea
                      value={getContent('corporate_group', `facility_${num}`, 'desc', def.desc)}
                      onChange={(e) => updateField(`corporate_group_facility_${num}`, 'desc', e.target.value)}
                      rows={2}
                    />
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('corporate_group', `facility_${num}`, 'section', content[`corporate_group_facility_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Fasilitas #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* 4 Paket Pertemuan & Acara */}
        <ContentSection title="4 Paket Pertemuan & Gathering">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((num) => {
              const defaults = [
                { name: 'Half Day Meeting', duration: '4 Jam Pemakaian', price: 'Mulai Rp 175.000 /pax' },
                { name: 'Full Day Meeting', duration: '8 Jam Pemakaian', price: 'Mulai Rp 275.000 /pax' },
                { name: 'Fullboard Residential', duration: 'Menginap 2 Hari 1 Malam', price: 'Mulai Rp 650.000 /pax' },
                { name: 'Outbound & Fun Gathering', duration: '1 Hari / Menyesuaikan', price: 'Custom Sesuai Kebutuhan' }
              ];
              const def = defaults[num - 1];
              return (
                <div key={num} className="p-4 bg-gray-50 rounded-xl border space-y-3">
                  <h4 className="font-semibold text-gray-900 text-sm">Paket #{num}</h4>
                  <div>
                    <Label className="text-xs">Nama Paket</Label>
                    <Input
                      value={getContent('corporate_group', `package_${num}`, 'name', def.name)}
                      onChange={(e) => updateField(`corporate_group_package_${num}`, 'name', e.target.value)}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <Label className="text-xs">Durasi</Label>
                      <Input
                        value={getContent('corporate_group', `package_${num}`, 'duration', def.duration)}
                        onChange={(e) => updateField(`corporate_group_package_${num}`, 'duration', e.target.value)}
                      />
                    </div>
                    <div>
                      <Label className="text-xs">Harga / Pax</Label>
                      <Input
                        value={getContent('corporate_group', `package_${num}`, 'price', def.price)}
                        onChange={(e) => updateField(`corporate_group_package_${num}`, 'price', e.target.value)}
                      />
                    </div>
                  </div>
                  <Button
                    size="sm"
                    onClick={() => saveContent('corporate_group', `package_${num}`, 'package', content[`corporate_group_package_${num}`]?.content || {})}
                    disabled={isSaving}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white"
                  >
                    <Save className="w-3.5 h-3.5 mr-1" />Simpan Paket #{num}
                  </Button>
                </div>
              );
            })}
          </div>
        </ContentSection>

        {/* Sales Fast-Response Banner */}
        <ContentSection title="Banner Kontak Corporate Sales">
          <div className="space-y-4">
            <div>
              <Label>Judul Banner</Label>
              <Input
                value={getContent('corporate_group', 'sales_banner', 'title', 'Butuh Respons Cepat Hari Ini?')}
                onChange={(e) => updateField('corporate_group_sales_banner', 'title', e.target.value)}
              />
            </div>
            <div>
              <Label>Deskripsi</Label>
              <Textarea
                value={getContent('corporate_group', 'sales_banner', 'subtitle', 'Hubungi tim sales & marketing kami langsung untuk survei lokasi (site visit), pengecekan ketersediaan tanggal, atau konsultasi susunan acara.')}
                onChange={(e) => updateField('corporate_group_sales_banner', 'subtitle', e.target.value)}
                rows={2}
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Nomor WhatsApp Sales</Label>
                <Input
                  value={getContent('corporate_group', 'sales_banner', 'whatsapp', '+62 811-3070-0206')}
                  onChange={(e) => updateField('corporate_group_sales_banner', 'whatsapp', e.target.value)}
                />
              </div>
              <div>
                <Label>Email Reservasi</Label>
                <Input
                  value={getContent('corporate_group', 'sales_banner', 'email', 'reservasi@spencergreenhotel.com')}
                  onChange={(e) => updateField('corporate_group_sales_banner', 'email', e.target.value)}
                />
              </div>
            </div>
            <Button
              onClick={() => saveContent('corporate_group', 'sales_banner', 'banner', content['corporate_group_sales_banner']?.content || {})}
              disabled={isSaving}
              className="bg-emerald-600 hover:bg-emerald-700 text-white"
            >
              <Save className="w-4 h-4 mr-2" />Simpan Banner Kontak
            </Button>
          </div>
        </ContentSection>
      </TabsContent>
    </>
  );
};

export default LandingPagesContent;

